import { render } from "./AccountLocked.vue?vue&type=template&id=04380c3c&scoped=true"
import script from "./AccountLocked.vue?vue&type=script&lang=js"
export * from "./AccountLocked.vue?vue&type=script&lang=js"

import "./AccountLocked.vue?vue&type=style&index=0&id=04380c3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2_clean-css@5.3.3_c_e9026addebec4d340c62c6097892aed2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04380c3c"]])

export default __exports__